import React from 'react';
import { motion } from 'framer-motion';

interface ProgressBarProps {
  value: number; // 0 to 100
  variant?: 'streak' | 'primary' | 'success';
  className?: string;
  height?: string;
  showLabel?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  variant = 'primary',
  className = '',
  height = 'h-2',
  showLabel = false,
}) => {
  // Clamp value between 0 and 100
  const clampedValue = Math.min(100, Math.max(0, value));

  const bgVariants = {
    primary: 'bg-gradient-to-r from-primary to-accent',
    streak: 'bg-gradient-to-r from-orange-400 to-red-500',
    success: 'bg-gradient-to-r from-green-400 to-emerald-500',
  };

  return (
    <div className={`w-full ${className}`}>
      {showLabel && (
        <div className="flex justify-between items-center mb-1.5 text-xs font-semibold">
          <span className="text-[#6B6B80]">Progress</span>
          <span className="text-[#F0F0F5]">{clampedValue}%</span>
        </div>
      )}
      <div className={`w-full bg-white/[0.04] rounded-full overflow-hidden ${height}`}>
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${clampedValue}%` }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className={`h-full rounded-full ${bgVariants[variant]}`}
        />
      </div>
    </div>
  );
};
